<template>
  <div class="alert alert-dismissible fade show" :class="type" role="alert">
    {{text}}
    <button
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props:{
      type: String,
      text: String
  }
};
</script>

<style>
</style>